import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'; 

@Component({
    selector: 'app-case-studies-details-page',
    templateUrl: './case-studies-details-page.component.html',
    styleUrls: ['./case-studies-details-page.component.scss']
})
export class CaseStudiesDetailsPageComponent1 implements OnInit {

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.router.events.subscribe((event) => { 
            if (!(event instanceof NavigationEnd)) { 
                return; 
            } 
            window.scrollTo(0, 0) 
        }); 
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Case Study: Detecting Missing Labels and Missing Contents on Packaging Belt',
            subTitle: '1',
        }
    ]

    caseStudiesDetailsDesc: DetailsDesc[] = [
        {
            subTitle: 'Defect Detection, Quality Assurance, Anomaly Detection',
            img1: 'https://imgvid.blob.core.windows.net/imgvid/about.png',
            title1: 'Company Overview',
            paragraph1: 'CentralPharma is a mid-sized packaging company headquartered in Bedford, United Kingdom, specializing in manufacturing, processing, filling and packaging of pharmaceutical drugs and devices. They constantly face challenges with missing labels and missing contents in packages, which led to rejection of complete lot and therefore financial losses.',
            title2: 'Problem Statement',
            paragraph2: 'CentralPharma Solutions was experiencing a 3.5% rate of missing labels and a 2% rate of missing contents in their packaged products. The objective was to reduce the percentage of missing labels and missing contents to below 0.5% with the help of state-of-the-art AI-powered camera systems.',
            title3: 'Solution',
            paragraph3: 'CentralPharma Solutions partnered with Awareye in early 2024 to integrate an advanced computer vision system into their packaging lines. The system utilized high-resolution cameras mounted on the packaging lines and fine-tuned computer vision models to inspect each package in real-time.',
            title4: 'Implementation',
            title5: 'Results',
            title6: "Conclusion",
            paragraph6: 'By integrating Awareye’s advanced camera system with OTA updates, CentralPharma Solutions achieved significant reductions in packaging errors. This not only improved operational efficiency but also enhanced customer satisfaction and reduced financial losses due to returns. The success of this implementation demonstrates the value of leveraging AI and computer vision technologies in quality control processes within the packaging industry.',
        }
    ]
    ImplementationDetails: BulletPointDetails[] = [
        {
            title: 'System Design and Integration',
            details: [
                'Cameras: High-resolution cameras were installed at critical points on the packaging line—specifically, after the labeling and content insertion stages.',
                'AI Model Training: Awareye developed and trained models using a dataset of correctly labeled and filled packages, as well as examples of common errors (missing labels and contents).',
                'OTA Updates: The AI system was configured to receive Over-the-Air (OTA) updates, ensuring the algorithms remained effective whenever there was any change in the package contents or label format.'
            ]
        },
        {
            title: 'Inspection Process',
            details: [
                'Label Verification: Cameras captured images of each package after labeling. The model analyzed the images to verify the presence and correctness of labels.',
                'Content Verification: Another set of cameras checked the package contents before sealing. The model ensured all required items were present.',
                'Error Handling: Packages identified with missing labels or contents were automatically diverted to a rework station for correction.'
            ]
        },
        {
            title: 'Data Analytics and Reporting',
            details: [
                'Real-time Monitoring: The system provided real-time data on inspection results, allowing operators to monitor the packaging process and identify trends.',
                'Historical Analysis: Detailed reports were generated to analyze the frequency and types of errors, enabling CentralPharma Solutions to implement further process improvements.'
            ]
        }
    ]
    ResultDetails: BulletPointDetails[] = [
        {
            title: 'Reduction in Errors',
            details: [
                'Missing labels reduced from 3.5% to 0.8%.',
                'Missing contents reduced from 2% to 0.4%'
            ]
        },
        {
            title: 'Improved Efficiency',
            details: [
                'The automated inspection process reduced the need for manual quality checks, freeing up staff for other tasks.',
                'The rework rate decreased significantly, leading to faster overall production times.'
            ]
        },
        {
            title: 'Enhanced Customer Satisfaction',
            details: [
                'The reduction in packaging errors led to fewer discards and refunds.',
                'Positive customer feedback and the company’s reputation for quality improved.'
            ]
        }
    ]
    caseStudiesDetailsInfo: Info[] = [
        {
            icon: 'bx bx-user-pin',
            title: 'Client',
            subTitle: 'CentralPharma Limited',
        },
        {
            icon: 'bx bx-globe',
            title: 'Website',
            subTitle: 'https://www.centralpharma.com',
        },
        {
            icon: 'bx bx-map',
            title: 'Location',
            subTitle: 'Elm Farm Industrial Estate, Bedford, MK41 0XZ, United Kingdom',
        },
        {
            icon: 'bx bx-purchase-tag',
            title: 'Industry',
            subTitle: 'Manufacturing/Packaging',
        },
        {
            icon: 'bx bx-check',
            title: 'Completed',
            subTitle: 'March 2024',
        }
    ]

}
class pageTitle {
    title : string;
    subTitle : string;
}
class DetailsDesc {
    subTitle : string;
    title1 : string;
    title2 : string;
    title3 : string;
    title4 : string;
    title5 : string;
    title6 : string;
    img1 : string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
    paragraph6: string;
}
class BulletPointDetails {
    title : string;
    details : string[];
}
class Info {
    icon : string;
    title : string;
    subTitle : string;
}